<!--<div class="mat-table__message" *ngIf="!baseDataTableComponent.hasItems">No records found</div>-->
<!-- <div class="mat-table__message" *ngIf="baseDataTableComponent.isPreloadTextViewedSubject | async">Please wait....</div> -->
<!-- <div class="mat-table__bottom" *ngIf="baseDataTableComponent.hasItems"> -->
<!--<mat-spinner [diameter]="20" *ngIf="baseDataTableComponent.finishLoading | async"></mat-spinner>-->
<!--{{ baseDataTableComponent.totalItem }}-->
<!--<div [class]="isLoading ? 'w-100' : 'd-none'">-->
<!--</div>-->
<mat-paginator
  #paginator
  *ngIf="baseDataTableComponent.finishLoading | async"
  (page)="handlePage($event)"
  [pageIndex]="pageNumber"
  [pageSize]="baseDataTableComponent.pageSize"
  [pageSizeOptions]="baseDataTableComponent.pageSizeSelect"
  [length]="baseDataTableComponent.totalItem"
  appTablePaginator
></mat-paginator>

<!--{{ baseDataTableComponent.finishLoading | async}}-->
<!-- pagination loader -->
<div class="w-100 justify-content-between d-flex align-items-center" *ngIf="(baseDataTableComponent.finishLoading | async) === false">
  <div class="skeleton_group_bottom_table">
    <div>
      <ngx-skeleton-loader count="1" [theme]="{ 'border-radius': '5', height: '30px', width: '70px' }"></ngx-skeleton-loader>
    </div>
    <ngx-skeleton-loader count="1" [theme]="{ 'border-radius': '5', height: '30px', width: '180px' }"></ngx-skeleton-loader>
  </div>
  <div *ngIf="!isLoading">
    <ngx-skeleton-loader
      count="4"
      appearance="circle"
      [theme]="{
        'width.px': 30,
        'height.px': 30,
        'border-radius': '5px'
      }"
    >
    </ngx-skeleton-loader>
  </div>
</div>
